<template>
  <div
    v-if="condition !== null">
    <label class="label">
      {{ label }}
    </label>
    <div
      class="activity-result-input">
      <ActivityResultConditionInitButton
        v-if="isShowInitButton"
        :condition="condition"
        @click="onClickInitButton" />
      <div
        v-else
        class="select-2-item">
        <select
          :id="`select2-${condition.name}-1`"
          class="item1"
          :value="value1"
          @input="onInputValue1">
          <option
            v-for="option of condition.options1"
            :key="option.value"
            :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <select
          class="item2"
          :value="value2"
          @input="onInputValue2">
          <option
            v-for="option of condition.options2"
            :key="option.value"
            :value="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityResultConditionInitButton from '@/components/parts/ActivityResultConditionInitButton.vue'
export default {
  components: {
    ActivityResultConditionInitButton
  },
  props: {
    condition: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isShowInitButton: false,
    }
  },
  computed: {
    value1() {
      return this.value.split(this.condition.splitMarker)[0]
    },
    value2() {
      return this.value.split(this.condition.splitMarker)[1]
    },
    splitValue() {
      return this.value.split(this.splitMarker)
    },
    label() {
      return this.condition.label
    },
    splitMarker() {
      return this.condition.splitMarker
    }
  },
  created() {
    if (this.value == null) {
      this.isShowInitButton = true
    }
  },
  methods: {
    onInputValue1(e) {
      const value1 = e.target.value
      const newValue = `${value1}${this.splitMarker}${this.value2}`
      this.$emit('input', newValue)
    },
    onInputValue2(e) {
      const value2 = e.target.value
      const newValue = `${this.value1}${this.splitMarker}${value2}`
      this.$emit('input', newValue)
    },
    onClickInitButton() {
      this.isShowInitButton = false
      this.$emit('input', this.condition.initValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  margin-bottom: 5px;
  text-align: center;
  width: 100%;
}
.activity-result-input {
  background-color: $white;
  color: $l-blue;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.select-2-item {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;

  select {
    background: none;
    color: $l-blue;
    border: none;
    height: 100%;
    text-align-last: center;
    padding: 0;
    appearance: none;
  }
}
</style>